import { render, staticRenderFns } from "./PaperStarting.vue?vue&type=template&id=52a0168c&scoped=true"
import script from "./PaperStarting.vue?vue&type=script&lang=js"
export * from "./PaperStarting.vue?vue&type=script&lang=js"
import style0 from "./PaperStarting.vue?vue&type=style&index=0&id=52a0168c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0168c",
  null
  
)

export default component.exports